import { combineReducers } from "redux";
import AllReducers from "../action";

const rootReducer = combineReducers({ ...AllReducers });

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer;
